import { alpha } from '@mui/material';
import dayjs from 'dayjs';
import Localization from 'l18n/l18n';
import CalendarSettings from 'models/calendar';
import * as React from 'react';

export const AppointmentCalendarContext = React.createContext();

export const useAppointmentsCalendarContext = () =>
  React.useContext(AppointmentCalendarContext);
const AppointmentCalendarProvider = ({ children }) => {
  const [context, setContext] = React.useState({
    // all appointments data that recived from the api and the patient_info_id is not null
    appointmentsData: [],
    currentWeek: dayjs(),
    // calendar start time and end time
    timeDuration: {
      startTime: dayjs().get('h'),
      endTime: dayjs().add(1).get('h'),
    },
    // cell duration in minutes
    cellTimeDuration: 30,
    // cell styles for exeptions cells
    calendarExeptionStyle: {
      fontColor: alpha('#000000', 0.5),
      workBreakBackgroundColor: alpha('rgba(0,255,0)', 0.2),
      bookedBackgroundColor: alpha('rgba(255,0,0)', 0.2),
      vicationBackgroundColor:
        'repeating-linear-gradient( 135deg, rgba(54, 82, 244, 0.1), rgba(54, 174, 244, 0.26) 4px,transparent 4px,transparent 9px)',
      exceptionBackgroundColor:
        'repeating-linear-gradient( 135deg, rgba(244, 82, 54, 0.1), rgba(244, 174, 54, 0.26) 4px,transparent 4px,transparent 9px)',
    },
    calendarSettings: {
      // days ordered by name , sunday to Saturday. do not change the id and the order of the array
      weekDays: [
        {
          id: 0,
          name: Localization.translate['week_days'][0],
          executed: false,
        },
        {
          id: 1,
          name: Localization.translate['week_days'][1],
          executed: false,
        },
        {
          id: 2,
          name: Localization.translate['week_days'][2],
          executed: false,
        },
        {
          id: 3,
          name: Localization.translate['week_days'][3],
          executed: false,
        },
        {
          id: 4,
          name: Localization.translate['week_days'][4],
          executed: false,
        },
        {
          id: 5,
          name: Localization.translate['week_days'][5],
          executed: false,
        },
        {
          id: 6,
          name: Localization.translate['week_days'][6],
          executed: false,
        },
      ],
    },
  });

  const UpdateContext = (name, newValue) => {
    setContext(() => {
      return { ...context, [name]: newValue };
    });
  };
 
  const AppointmentProvider = React.useMemo(() => {
    return {
      ...context,
      setCurrentWeek: (date) => UpdateContext('currentWeek', date),
      setTimeDuration: (newTime) => UpdateContext('timeDuration', newTime),
      setCellTimeDuration: (TimeInMinutes) => UpdateContext('cellTimeDuration', TimeInMinutes),
      setCalendarSettings: (settings) => UpdateContext('calendarSettings', settings),
      setContext
    };
  }, [context]);

  React.useEffect(() => {
    // get weekEnds
    CalendarSettings.getWeekends()
      .then((res) => {
        const weekDays = res.week_ends;
        // convert the result to the same schema as the weekDays state in the calendar settings state inside the appointment context
        let namedWeekDays = Object.entries(weekDays).map((day) => {
          return {
            id: day[0],
            executed: day[1],
            name: Localization.translate['week_days'][day[0]],
          };
        });

        AppointmentProvider.setCalendarSettings({
          ...AppointmentProvider.calendarSettings,
          // check if there was not any data from the api then display the original schema of the weekDays from appointment context
          weekDays:
            weekDays[0] !== undefined
              ? namedWeekDays
              : AppointmentProvider.calendarSettings.weekDays,
        });
      })
      .catch((err) => {
        console.log(err);
      });


  }, [context.weekDays,]);

  return (
    <AppointmentCalendarContext.Provider value={AppointmentProvider}>
      {children}
    </AppointmentCalendarContext.Provider>
  );
};

export default React.memo(AppointmentCalendarProvider);
